var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgIconPosition = function SvgIconPosition(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5.5A.5.5 0 0 1 2 1v9a.5.5 0 0 1-1 0V1a.5.5 0 0 1 .5-.5Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.4c0-.22.18-.4.4-.4h2.2c.22 0 .4.18.4.4v4.2a.4.4 0 0 1-.4.4H.4a.4.4 0 0 1-.4-.4V3.4Z",
    fill: "#787878"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4v3h1V4H1ZM.4 3a.4.4 0 0 0-.4.4v4.2c0 .22.18.4.4.4h2.2a.4.4 0 0 0 .4-.4V3.4a.4.4 0 0 0-.4-.4H.4ZM5.5.5A.5.5 0 0 1 6 1v9a.5.5 0 0 1-1 0V1a.5.5 0 0 1 .5-.5Z",
    fill: "#787878"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.4c0-.22.18-.4.4-.4h2.2c.22 0 .4.18.4.4v2.2a.4.4 0 0 1-.4.4H4.4a.4.4 0 0 1-.4-.4V2.4Z",
    fill: "#787878"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3v1h1V3H5Zm-.6-1a.4.4 0 0 0-.4.4v2.2c0 .22.18.4.4.4h2.2a.4.4 0 0 0 .4-.4V2.4a.4.4 0 0 0-.4-.4H4.4ZM9.5.5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0V1a.5.5 0 0 1 .5-.5Z",
    fill: "#787878"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.4c0-.22.18-.4.4-.4h2.2c.22 0 .4.18.4.4v4.2a.4.4 0 0 1-.4.4H8.4a.4.4 0 0 1-.4-.4V4.4Z",
    fill: "#787878"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5v3h1V5H9Zm-.6-1a.4.4 0 0 0-.4.4v4.2c0 .22.18.4.4.4h2.2a.4.4 0 0 0 .4-.4V4.4a.4.4 0 0 0-.4-.4H8.4Z",
    fill: "#787878"
  })));
};
export default SvgIconPosition;